import React, { useEffect, useState } from "react";
import logo from "../Images/logo-4.png";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { token,apiurl, BASEAPIURL } from "../env";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const login = async () => {
    if (!userId || !password) {
      setErrorMsg("Please enter both User ID and Password.");
      return;
    }

    setIsLoading(true);
    setErrorMsg("");

    try {
      // Fetch the public IP address
      const ipResponse = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipResponse.json();
      const clientIP = ipData.ip;

      const response = await fetch(
        `${BASEAPIURL}/Admin_VerifyLogin`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            user: userId,
            pwd: password,
            CompID: 3,
            tokenData:
              "OWdBQUFCK0xDQUFBQUFBQUFBbzlqczBPZ2pBUWhGK2w2ZGtRa0FRU2JpcGUvUW5xdmNKcURLV3R1MFZDakQ2N0xjRm1UN1B6VFdiZWZLTTdJOVM0RXgzd3dpbFZnN0hzQkMycnRPenRReXUrNEpXKzJVRWcvQ25aWDlrZUcwQzJNc2I1RjBEeVpNR1RLUGJuTTRBdndEbEI5NldTM1VoUG1SdEpiVVJROXdnMElaRUNHL2lEUnV2NE5JMno4RHM3Ym03MWF5Y1plRUUwYUd5Y2YweUhyUDJxUEFsbXVaN3J0LzlzS2F6Z254OHFwQWVYOWdBQUFBPT0=",
            ipAddress: clientIP, // ✅ Add IP address here
          }),
        }
      );

      const result = await response.json();
      console.log("Login Response:", result);

      if (String(result.status).toLowerCase() === "true") {
        const LoginId = result.LoginID || result.data?.LoginID;
        sessionStorage.setItem("LoginID", LoginId);
        // setTimeout(() => sessionStorage.removeItem('LoginID'), 15 * 60 * 1000);

        await runCheckUpdatesAPI();
        navigate("/admindashboard");
      } else {
        setErrorMsg(
          result.message || "Login failed. Please check your credentials."
        );
      }
    } catch (error) {
      console.error("Login Error:", error);
      setErrorMsg("An error occurred while logging in. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const runCheckUpdatesAPI = async () => {
    try {
      const response = await fetch(`${BASEAPIURL}/CheckUpdates`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tokenData: token }),
      });
      const result = await response.text();
      console.log("CheckUpdates Response:", result);
    } catch (error) {
      console.error("CheckUpdates Error:", error);
    }
  };

  useEffect(() => {
    const LoginId = sessionStorage?.getItem("LoginID");
    if (LoginId) {
      navigate("/admindashboard");
    }
  });

  return (
    <>
      <style>{`
        .admin-login-container {
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background: linear-gradient(135deg, #2c0e18, #3a0d1c, #5a1e2f);
          padding: 20px;
        }
        .login-card {
          background: #fff;
          padding: 2rem 2.5rem;
          border-radius: 20px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.2);
          max-width: 420px;
          width: 100%;
          animation: fadeInUp 0.5s ease;
        }
        .login-logo { width: 80px; }
        h4.text-primary { color: #8b0000 !important; font-weight: 600; }
        .password-wrapper { position: relative; }
        .password-wrapper input {
          padding-right: 40px;
          border-radius: 10px;
          height: 45px;
        }
        .password-toggle {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
          color: #666;
          background: none;
          border: none;
        }
        .btn-primary {
          background: #8b0000;
          border: none;
          border-radius: 10px;
          padding: 0.7rem;
          font-weight: 500;
          transition: background 0.3s ease;
        }
        .btn-primary:hover { background: #a80000; }
        .alert { border-radius: 10px; }
        @keyframes fadeInUp {
          from { transform: translateY(20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>

      <div className="admin-login-container">
        <div className="login-card">
          <div className="text-center mb-4">
            <img src={logo} alt="Logo" className="login-logo" />
            <h4 className="mt-3 text-primary">Admin Login</h4>
          </div>

          {errorMsg && (
            <div className="alert alert-danger py-2 text-center" role="alert">
              {errorMsg}
            </div>
          )}

          {/* ✅ Form ensures Enter key triggers login */}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              login();
            }}
            className="admin-login-form"
          >
            <div className="mb-3">
              <label htmlFor="userId" className="form-label">
                User ID
              </label>
              <input
                type="text"
                className="form-control"
                id="userId"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                placeholder="Enter user ID"
                required
                autoFocus
              />
            </div>

            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  required
                />
                <button
                  type="button" // ✅ prevents Enter key from submitting here
                  className="password-toggle"
                  onClick={togglePasswordVisibility}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                </button>
              </div>
            </div>

            <div className="mb-3 text-end">
              <a
                href="/forgot-password"
                className="text-decoration-none small text-secondary"
              >
                Forgot password?
              </a>
            </div>

            <div className="d-grid mb-3">
              <button
                type="submit"
                className="btn btn-primary w-100"
                disabled={isLoading}
              >
                {isLoading && (
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
                {isLoading ? "Logging In..." : "Log In"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
